module.exports = __webpack_public_path__ + "img/petya.4446dad2.webp";